export default "__VITE_ASSET__CjGBhw3L__"